import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {Agent, AgentState} from "@/modules/agent/types";
import {deleteAgent, getAgent, getAgents, saveAgent, updateAgent} from "@/services/agent";

export const state: AgentState = {
  agent: {
    id_company: "",
    name: "",
    position: "",
    phone: "",
    email: "",
  }
}

const actions: ActionTree<AgentState, RootState> = {
  async GET_AGENT(_, id) {
    return await getAgent(id);
  },
  async GET_AGENTS() {
    return await getAgents();
  },
  async SAVE_AGENT(_, agent: Agent) {
    return await saveAgent(agent);
  },
  async DELETE_AGENT(_, id) {
    return await deleteAgent(id);
  },
  async UPDATE_AGENT(_, payload) {
    return await updateAgent(payload);
  }
}

const mutations: MutationTree<AgentState> = {
  SET_AGENT(state, agent: Agent) {
    state.agent = agent;
  }
}

const getters: GetterTree<AgentState, RootState> = {
  AGENT(state): Agent {
    const {agent} = state;
    return {...agent};
  }
}

export const agent: Module<AgentState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
